export const ENTRYPOINT = 'https://dev.api.app.bbsperanta.ro';



// WEBPACK FOOTER //
// ./src/config/entrypoint.js